import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { UserFormDto, type UserFormInterface } from '@zaoblako/shared/modules/security/dtos/user/user-form.dto';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';

/** User creation request body */
export interface UserCreateInterface extends UserFormInterface {
  /** User profile data */
  profile: ProfileFindInterface;
}

/** User creation request body - DTO schema */
export const UserCreateDto = SerdeDtoClass.from<UserFormInterface, UserCreateInterface>(UserFormDto, SecurityDtoKeysEnum.USER_CREATE_DTO, {
  profile: {
    label: 'Профиль',
    serializer: entityLikeSchema,
    checkers: [SecurityBackendValidatorsEnum.PROFILE_ASSERT_EXISTS_BY_DTO],
  },
});
